import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";

function ComicDetail() {
    const { id } = useParams();
    const [comic, setComic] = useState(null);
    const [chapters, setChapters] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/comics/${id}`)
            .then(res => setComic(res.data))
            .catch(() => setError("Failed to load data"));

        axios
            .get(`${process.env.REACT_APP_API_URL}/api/chapters/comic/${id}`)
            .then(res => setChapters(res.data.chapters || []))
            .catch(() => setError("Failed to load chapters"));

    }, [id]);

    if (error) return <p className="container" style={{ color: "red" }}>{error}</p>;
    if (!comic) return <p className="container">Loading...</p>;

    return (
        <div className="container">
            <Link to="/" className="btn" style={{ marginBottom: "20px", background: "gray" }}>⬅ Back</Link>

            <h1 style={{ marginTop: "20px" }}>{comic.title}</h1>
            <p>{comic.description}</p>

            <h2 style={{ borderBottom: "1px solid var(--border-color)", paddingBottom: "10px" }}>Chapters</h2>
            {chapters.length === 0 ? (
                <p>No chapters yet</p>
            ) : (
                <ul style={{ listStyle: "none", padding: 0 }}>
                    {chapters.map(ch => (
                        <li key={ch._id} style={{
                            padding: "10px 0",
                            borderBottom: "1px solid var(--border-color)"
                        }}>
                            <Link to={`/read/${ch._id}`} style={{ display: "block", color: "var(--primary-color)", fontWeight: "500", fontSize: "16px" }}>
                                Chapter {ch.chapterNumber}: {ch.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default ComicDetail;
